import React from "react";
import { Modal } from "reactstrap";

const RemoveHierarchyModal = ({
  isDeleteHierarchy,
  toggleDeleteHierarchy,
  onDeleteHierarchy,
  onDeleteEvent,
  eventId,
}) => {
  return (
    <Modal
      className="manager-program-settings-dialog modal-md"
      isOpen={isDeleteHierarchy}
      toggle={toggleDeleteHierarchy}
      centered
    >
      <div className="manager-program-settings-dialog__header">
        <div className="manager-program-settings-dialog__header-copy">
          <h4 className="manager-program-settings-dialog__title">Remove event</h4>
          <p className="manager-program-settings-dialog__description">
            Choose whether to remove this event only from the current program or
            across the full hierarchy.
          </p>
        </div>
        <button
          type="button"
          className="manager-program-settings-dialog__close"
          onClick={toggleDeleteHierarchy}
          aria-label="Close"
        >
          Close
        </button>
      </div>
      <div className="manager-program-settings-dialog__body">
        <div className="manager-program-settings-dialog__actions">
          <button
            type="button"
            className="manager-program-settings-dialog__action is-danger"
            onClick={() => onDeleteEvent(null, eventId)}
          >
            This program only
          </button>
          <button
            type="button"
            className="manager-program-settings-dialog__action is-primary"
            onClick={onDeleteHierarchy}
          >
            Entire hierarchy
          </button>
          <button
            type="button"
            className="manager-program-settings-dialog__action"
            onClick={toggleDeleteHierarchy}
          >
            Cancel
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default RemoveHierarchyModal;
